import React, {useState, useEffect} from 'react';
import {
    Card,
    Table,
    Form,
    Button as BSButton,
    Row,
    Col,
    Tabs,
    Tab
} from 'react-bootstrap';
import {useHistory, useLocation} from 'react-router-dom';
import {useMutation, useQuery} from 'react-query';
import {Get, Post} from '@app/utils/httpProvider';
import {
    MAINTENANCE_BATCH_API,
    ASSET_API,
    MATERIALCATALOG_API,
    ASSETSTATUS_API,
    DEPARTMENT_API
} from '@app/utils/apiUrl';
import {URI_INTERNAL} from '@app/utils/pathLocations';
import {toast} from 'react-toastify';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import {messageToast, status200} from '../../utils/define';
import ReactSpinner from '../../components/reactSpinner/ReactSpinner';
import {getInfomationAccountFromToken} from '@app/utils/helper';
import {getByIdAccountAction} from '@app/store/reducers/account';
import {useDispatch, useSelector} from 'react-redux';
import {userManager} from '@app/utils/oidc';

const batchTypeOptions = [
    {value: 'Sửa chữa', label: 'Sửa chữa'},
    {value: 'Bảo dưỡng định kỳ', label: 'Bảo dưỡng định kỳ'},
    {value: 'Bảo hành', label: 'Bảo hành'},
    {value: 'Nâng cấp', label: 'Nâng cấp'}
];

const MaintenanceBatchAdd = () => {
    const history = useHistory();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const preSelectedAssetId = queryParams.get('assetId');

    const [isSaving, setIsSaving] = useState(false);
    const [activeTab, setActiveTab] = useState('assets');
    const dispatch = useDispatch();
    const itemAccount = useSelector((state) => state.account.itemAccount);

    const [batchCode] = useState(`SC-${Date.now()}`);
    const [batchTitle, setBatchTitle] = useState('');
    const [batchNotes, setBatchNotes] = useState('');
    const [performedBy, setPerformedBy] = useState('');
    const [batchType, setBatchType] = useState('Sửa chữa');

    // #viet_code: Tự động lấy tên người thực hiện
    React.useEffect(() => {
        const fetchInitialUser = async () => {
            // 1. Thử lấy từ Token thô (nhanh nhất)
            const accountInfo = getInfomationAccountFromToken();
            if (accountInfo) {
                const tokenName = accountInfo.fullName || accountInfo.name || accountInfo.fullname || accountInfo.given_name || accountInfo.preferred_username;
                if (tokenName) setPerformedBy(tokenName);
                
                // Fetch để lấy tên chính xác nhất từ DB (nếu token chỉ có username)
                const userId = accountInfo.id || accountInfo.sub;
                if (userId) dispatch(getByIdAccountAction(userId));
            }
        };

        fetchInitialUser();
    }, [dispatch]);

    React.useEffect(() => {
        const target = itemAccount?.data || itemAccount;
        const nameFromDb = target?.fullName || target?.fullname || target?.FullName || target?.name;
        
        if (nameFromDb) {
            setPerformedBy(nameFromDb);
            // Đồng bộ xuống các dòng trong bảng
            setRows(prev => prev.map(r => r.performedBy === '' ? {...r, performedBy: nameFromDb} : r));
        }
    }, [itemAccount]);
    const [errors, setErrors] = useState({});

    const assetQuery = useQuery(['assetsDataForBatch'], () =>
        Get(ASSET_API.GET_PAGING, null, {PageIndex: 1, PageSize: 10000, IsDisposed: false})
    );

    // Load danh mục trạng thái tài sản
    const assetStatusQuery = useQuery(['assetStatuses'], () =>
        Get(ASSETSTATUS_API.GET_PAGING, null, {PageIndex: 1, PageSize: 1000})
    );

    const departmentQuery = useQuery(['departmentsDataForBatch'], () =>
        Get(DEPARTMENT_API.GET_PAGING, null, {PageIndex: 1, PageSize: 1000})
    );

    const departmentOptions =
        departmentQuery.data?.data?.map((d) => ({
            value: d.id,
            label: d.departmentName || d.name || ''
        })) || [];

    const assetOptions =
        assetQuery.data?.data?.filter(a => !a.isDisposed).map((a) => {
            const status = assetStatusQuery.data?.data?.find(
                (s) => s.id === a.assetStatusId
            );
            const statusName = status ? status.statusName : '';
            return {
                value: a.id,
                label: `${a.assetCode} - ${a.assetName} [${statusName}]`,
                assetCode: a.assetCode,
                statusName: statusName,
                departmentId: a.currentDepartmentId,
                departmentName: a.departmentName || a.department?.departmentName || '', // #viet_code
                isDisabled: statusName === 'Đang sửa chữa' || statusName === 'Điều chuyển' || statusName === 'Đang điều chuyển' || statusName === 'Chờ phê duyệt'
            };
        }).filter(opt => opt.statusName !== 'Đào thải') || [];

    // Load danh mục vật tư/phụ kiện
    const catalogQuery = useQuery(['materialCatalog'], () =>
        Get(MATERIALCATALOG_API.GET_PAGING, null, {
            PageIndex: 1,
            PageSize: 1000
        })
    );
    const catalogOptions =
        catalogQuery.data?.data?.map((m) => ({
            value: m.id,
            label: `${m.materialCode || m.code || ''} - ${
                m.materialName || m.name || ''
            }`
        })) || [];

    const [rows, setRows] = useState([
        {
            id: Date.now(),
            departmentId: null,
            assetId: preSelectedAssetId ? Number(preSelectedAssetId) : null,
            eventCode: `EVT-${Date.now()}`,
            eventName: '',
            eventDate: new Date(),
            endDate: null,
            frequency: '',
            performedBy: '',
            deviceError: '',
            cost: 0,
            repairCount: 1,
            isInRepair: false
        }
    ]);

    const [materials, setMaterials] = useState([]);

    const addRow = () => {
        setRows([
            ...rows,
            {
                id: Date.now() + Math.random(),
                departmentId: null,
                assetId: null,
                eventCode: `EVT-${Math.floor(Date.now() / 1000)}`,
                eventName: '',
                eventDate: new Date(),
                endDate: null,
                frequency: '',
                performedBy: performedBy || '',
                deviceError: '',
                cost: 0,
                repairCount: 1,
                isInRepair: false
            }
        ]);
    };

    const removeRow = (id) => {
        if (rows.length > 1) {
            setRows(rows.filter((r) => r.id !== id));
            // Xóa vật tư liên quan
            setMaterials(materials.filter((m) => m.rowId !== id));
        } else {
            toast.warn('Phải có ít nhất 1 dòng!');
        }
    };

    const checkAssetStatus = (assetId, assetLabel, statusName) => {
        if (statusName === 'Đang sửa chữa') {
            toast.warning(
                `Tài sản [${assetLabel}] này đang có trạng thái "Đang sửa chữa". Vui lòng kiểm tra lại!`,
                {
                    autoClose: 5000,
                    position: 'top-center'
                }
            );
            return true;
        }

        if (statusName === 'Điều chuyển' || statusName === 'Đang điều chuyển') {
            toast.error(
                `Tài sản [${assetLabel}] này đang trong quá trình "Điều chuyển". Không thể thêm vào phiếu sửa chữa!`,
                {
                    autoClose: 5000,
                    position: 'top-center'
                }
            );
            return true;
        }

        if (statusName === 'Chờ phê duyệt') {
            toast.error(
                `Tài sản [${assetLabel}] này đang có trạng thái "Chờ phê duyệt" ở một phiếu sửa chữa khác. Không thể thêm tiếp!`,
                {
                    autoClose: 5000,
                    position: 'top-center'
                }
            );
            return true;
        }
        return false;
    };

    const updateRow = async (id, field, value, extraData = null) => {
        let isInRepairValue = false;
        if (field === 'assetId' && value) {
            isInRepairValue = checkAssetStatus(
                value,
                extraData?.label || value,
                extraData?.statusName || ''
            );
        }
        setRows((prev) =>
            prev.map((r) =>
                r.id === id
                    ? {
                          ...r,
                          [field]: value,
                          departmentId: field === 'assetId' ? (extraData?.departmentId || r.departmentId) : r.departmentId,
                          departmentName: field === 'assetId' ? (extraData?.departmentName || '') : r.departmentName, // #viet_code
                          isInRepair:
                              field === 'assetId'
                                  ? isInRepairValue
                                  : r.isInRepair
                      }
                    : r
            )
        );
    };

    const handleDepartmentChange = (id, opt) => {
        setRows((prev) =>
            prev.map((r) =>
                r.id === id
                    ? {
                          ...r,
                          departmentId: opt?.value || null,
                          departmentName: opt?.label || '',
                          assetId: null, // Clear asset when department changes
                          isInRepair: false
                      }
                    : r
            )
        );
    };

    const addMaterial = () => {
        setMaterials([
            ...materials,
            {
                id: Date.now() + Math.random(),
                rowId: rows[0]?.id || 0, // Gán vào dòng đầu tiên (backend yêu cầu gắn vào event)
                materialCatalogId: null,
                quantity: 1,
                unitPrice: 0,
                note: ''
            }
        ]);
    };

    const updateMaterial = (id, field, value) => {
        setMaterials(
            materials.map((m) => (m.id === id ? {...m, [field]: value} : m))
        );
        // Clear error when user inputs
        if (errors.materials) {
            const index = materials.findIndex(m => m.id === id);
            if (index !== -1 && errors.materials[index]?.[field]) {
                const newMatErrors = [...errors.materials];
                newMatErrors[index][field] = null;
                setErrors({ ...errors, materials: newMatErrors });
            }
        }
    };

    const removeMaterial = (id) => {
        setMaterials(materials.filter((m) => m.id !== id));
        if (errors.materials) {
            const index = materials.findIndex(m => m.id === id);
            if (index !== -1) {
                const newMatErrors = [...errors.materials];
                newMatErrors.splice(index, 1);
                setErrors({ ...errors, materials: newMatErrors });
            }
        }
    };

    const handleSave = async () => {
        let newErrors = {};
        if (!batchTitle) newErrors.batchTitle = 'Tiêu đề không được để trống';
        if (!performedBy) newErrors.performedBy = 'Người thực hiện không được để trống';

        const rowErrors = rows.map((r) => {
            let rowErr = {};
            if (!r.assetId) rowErr.assetId = 'Chọn tài sản';
            if (!r.eventName) rowErr.eventName = 'Nhập nội dung';
            return rowErr;
        });

        const rowInvalid = rowErrors.some((e) => Object.keys(e).length > 0);
        if (rowInvalid) newErrors.rows = rowErrors;

        const materialErrors = materials.map((m) => {
            let matErr = {};
            if (!m.materialCatalogId) matErr.materialCatalogId = 'Chọn vật tư';
            if (!m.quantity || m.quantity <= 0) matErr.quantity = 'Số lượng > 0';
            return matErr;
        });
        const matInvalid = materialErrors.some((e) => Object.keys(e).length > 0);
        if (matInvalid) newErrors.materials = materialErrors;

        setErrors(newErrors);

        if (Object.keys(newErrors).length > 0) {
            toast.error('Vui lòng nhập đủ thông tin');
            return;
        }

        const costInvalid = rows.some((r) => parseFloat(r.cost) < 0);
        if (costInvalid) {
            toast.error('Chi phí sửa chữa không được nhỏ hơn 0!');
            return;
        }

        const dateInvalid = rows.some((r) => {
            if (!r.endDate || !r.eventDate) return false;
            return new Date(r.endDate).setHours(0, 0, 0, 0) < new Date(r.eventDate).setHours(0, 0, 0, 0);
        });
        if (dateInvalid) {
            toast.error('Hạn hoàn thành không được nhỏ hơn ngày bắt đầu!');
            return;
        }

        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const startDateInvalid = rows.some(
            (r) =>
                r.eventDate &&
                new Date(r.eventDate).setHours(0, 0, 0, 0) < today
        );
        if (startDateInvalid) {
            toast.error('Ngày bắt đầu không được nhỏ hơn ngày hiện tại!');
            return;
        }

        const anyInRepair = rows.some((r) => r.isInRepair);
        if (anyInRepair) {
            toast.error(
                'Một hoặc nhiều tài sản đang trong quá trình sửa chữa khác. Không thể lưu phiếu!'
            );
            return;
        }

        const matPriceInvalid = materials.some(
            (m) => parseFloat(m.unitPrice) < 0 || parseFloat(m.quantity) < 0
        );
        if (matPriceInvalid) {
            toast.error('Số lượng và đơn giá vật tư không được nhỏ hơn 0!');
            return;
        }

        setIsSaving(true);
        try {
            const maintenanceEvents = rows.map((r, index) => {
                const finalMaterials =
                    index === 0
                        ? materials.map((m) => ({
                              materialCatalogId: m.materialCatalogId,
                              quantity: m.quantity,
                              unitPrice: m.unitPrice,
                              note: m.note
                          }))
                        : [];

                return {
                    assetId: parseInt(r.assetId),
                    eventCode: r.eventCode,
                    eventName: r.eventName,
                    description: r.eventName,
                    eventDate: r.eventDate,
                    endDate: r.endDate,
                    frequency: r.frequency,
                    performedBy: r.performedBy,
                    eventType: batchType,
                    deviceError: r.deviceError,
                    cost: parseFloat(r.cost) || 0,
                    repairCount: parseInt(r.repairCount) || 1,
                    materials: finalMaterials
                };
            });

            const submitData = {
                batchCode,
                title: batchTitle,
                notes: batchNotes,
                performedBy: performedBy,
                batchType: batchType,
                maintenanceEvents
            };

            const resp = await Post(
                MAINTENANCE_BATCH_API.CREATE,
                null,
                submitData
            );
            if (resp) {
                // Chuyển hướng ngay lập tức trước khi thực hiện các tác vụ UI khác
                history.push(URI_INTERNAL.MAINTENANCE_BATCH_PATH);
                toast.success('Lưu phiếu sửa chữa thành công!');
                return;
            }
        } catch (err) {
            toast.error(err?.message || 'Có lỗi khi lưu phiếu!');
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <div className="container-fluid">
            {isSaving && <ReactSpinner />}
            <Card className="shadow-sm border-0">
                <Card.Header className="bg-white py-3 border-bottom d-flex align-items-center">
                    <h5 className="mb-0 fw-bold text-primary">
                        <i className="fas fa-plus-circle mr-2" /> Tạo phiếu sửa chữa mới
                    </h5>
                    <BSButton
                        variant="outline-secondary"
                        size="sm"
                        onClick={() =>
                            history.push(URI_INTERNAL.MAINTENANCE_BATCH_PATH)
                        }
                        className="shadow-sm ml-auto"
                    >
                        <i className="fas fa-times" /> Huỷ bỏ
                    </BSButton>
                </Card.Header>
                <Card.Body>
                    <Row className="mb-3">
                        <Col md={2}>
                            <Form.Group>
                                <Form.Label className="small fw-bold">
                                    Mã phiếu (Tự động)
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    value={batchCode}
                                    readOnly
                                    className="bg-light"
                                    style={{fontSize: '13px'}}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group>
                                <Form.Label className="small fw-bold">
                                    Tiêu đề phiếu{' '}
                                    <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Ví dụ: Đợt sửa chữa máy tính phòng HC-NS tháng 4"
                                    value={batchTitle}
                                    onChange={(e) => {
                                        setBatchTitle(e.target.value);
                                        if (errors.batchTitle) setErrors({...errors, batchTitle: null});
                                    }}
                                    isInvalid={!!errors.batchTitle}
                                    style={{fontSize: '13px'}}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors.batchTitle}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col> 
                        <Col md={2}>
                            <Form.Group>
                                <Form.Label className="small fw-bold">
                                    Người thực hiện{' '}
                                    <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Tên người/đơn vị..."
                                    value={performedBy}
                                    onChange={(e) => {
                                        setPerformedBy(e.target.value);
                                        if (errors.performedBy) setErrors({...errors, performedBy: null});
                                    }}
                                    isInvalid={!!errors.performedBy}
                                    style={{fontSize: '13px'}}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors.performedBy}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                        <Col md={2}>
                            <Form.Group>
                                <Form.Label className="small fw-bold">
                                    Loại (Kiểu sửa chữa)
                                </Form.Label>
                                <Select
                                    options={batchTypeOptions}
                                    value={batchTypeOptions.find(o => o.value === batchType)}
                                    onChange={(opt) => setBatchType(opt.value)}
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            minHeight: '31px',
                                            fontSize: '13px'
                                        }),
                                        menuPortal: base => ({ ...base, zIndex: 9999 })
                                    }}
                                    menuPortalTarget={document.body}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group>
                                <Form.Label className="small fw-bold">
                                    Ghi chú
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Ghi chú thêm nếu có..."
                                    value={batchNotes}
                                    onChange={(e) =>
                                        setBatchNotes(e.target.value)
                                    }
                                    style={{fontSize: '13px'}}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Tabs
                        activeKey={activeTab}
                        onSelect={(k) => setActiveTab(k)}
                        className="mb-3 custom-tabs-minimal"
                        style={{borderBottom: '2px solid #f0f0f0'}}
                    >
                        <Tab
                            eventKey="assets"
                            title={
                                <span>
                                    <i className="fas fa-tools mr-1" /> 1. Danh
                                    sách thiết bị
                                </span>
                            }
                        >
                            <Table
                                striped
                                bordered
                                hover
                                responsive
                                size="sm"
                                className="mb-3 align-middle-table mobile-card-view"
                            >
                                <thead className="bg-secondary text-white text-center">
                                    <tr>
                                        <th
                                            style={{width: '40px'}}
                                            className="align-middle"
                                        >
                                            #
                                        </th>
                                        <th
                                            style={{width: '200px'}}
                                            className="align-middle"
                                        >
                                            Khoa
                                        </th>
                                        <th
                                            style={{width: '250px'}}
                                            className="align-middle"
                                        >
                                            Tài sản{' '}
                                            <span className="text-danger">
                                                *
                                            </span>
                                        </th>
                                        <th className="align-middle" style={{width: '200px'}}>
                                            Lỗi thiết bị
                                        </th>
                                        <th className="align-middle">
                                            Nội dung sửa chữa{' '}
                                            <span className="text-danger">
                                                *
                                            </span>
                                        </th>

                                        <th
                                            style={{width: '140px'}}
                                            className="align-middle"
                                        >
                                            Ngày bắt đầu
                                        </th>
                                        <th
                                            style={{width: '140px'}}
                                            className="align-middle"
                                        >
                                            Hạn hoàn thành
                                        </th>
                                        <th
                                            style={{width: '100px'}}
                                            className="align-middle"
                                        >
                                            Chi phí
                                        </th>
                                        <th
                                            style={{width: '40px'}}
                                            className="align-middle"
                                        >
                                            Xóa
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {rows.map((row, index) => (
                                        <tr key={row.id}>
                                            <td className="text-center align-top pt-2 stt-mobile" data-label="STT">
                                                {index + 1}
                                            </td>
                                            <td className="align-top pt-2" data-label="Khoa">
                                                <Select
                                                    options={departmentOptions}
                                                    value={departmentOptions.find(o => o.value === row.departmentId)}
                                                    onChange={(opt) => handleDepartmentChange(row.id, opt)}
                                                    placeholder="Chọn khoa..."
                                                    isClearable
                                                    isDisabled={!!row.assetId}
                                                    styles={{
                                                        control: (base) => ({
                                                            ...base,
                                                            height: '31px',
                                                            minHeight: '31px',
                                                            fontSize: '13px',
                                                        }),
                                                        valueContainer: (base) => ({
                                                            ...base,
                                                            height: '30px',
                                                            padding: '0 6px'
                                                        }),
                                                        input: (base) => ({
                                                            ...base,
                                                            margin: '0px'
                                                        }),
                                                        indicatorsContainer: (base) => ({
                                                            ...base,
                                                            height: '30px'
                                                        }),
                                                        menuPortal: (base) => ({
                                                            ...base,
                                                            zIndex: 9999
                                                        })
                                                    }}
                                                    menuPortalTarget={document.body}
                                                />
                                            </td>
                                            <td className="align-top pt-2" data-label="Tài sản *">
                                                <Select
                                                    options={assetOptions.filter(a => !row.departmentId || a.departmentId === row.departmentId)}
                                                    value={assetOptions.find(
                                                        (o) =>
                                                            o.value ===
                                                            row.assetId
                                                    )}
                                                    onChange={(opt) => {
                                                        updateRow(
                                                            row.id,
                                                            'assetId',
                                                            opt?.value,
                                                            opt
                                                        );
                                                        if (errors.rows?.[index]?.assetId) {
                                                            const newRowErrors = [...errors.rows];
                                                            newRowErrors[index].assetId = null;
                                                            setErrors({...errors, rows: newRowErrors});
                                                        }
                                                    }}
                                                    placeholder="Chọn tài sản..."
                                                    isClearable
                                                    isOptionDisabled={(option) => option.isDisabled}
                                                    styles={{
                                                        control: (base) => ({
                                                            ...base,
                                                            height: '31px',
                                                            minHeight: '31px',
                                                            fontSize: '13px',
                                                            borderColor: errors.rows?.[index]?.assetId ? '#dc3545' : base.borderColor,
                                                            '&:hover': {
                                                                borderColor: errors.rows?.[index]?.assetId ? '#dc3545' : base.borderColor
                                                            }
                                                        }),
                                                        valueContainer: (
                                                            base
                                                        ) => ({
                                                            ...base,
                                                            height: '30px',
                                                            padding: '0 6px'
                                                        }),
                                                        input: (base) => ({
                                                            ...base,
                                                            margin: '0px'
                                                        }),
                                                        indicatorsContainer: (
                                                            base
                                                        ) => ({
                                                            ...base,
                                                            height: '30px'
                                                        }),
                                                        menuPortal: (base) => ({
                                                            ...base,
                                                            zIndex: 9999
                                                        }),
                                                        option: (base, state) => ({
                                                            ...base,
                                                            color: state.isDisabled ? '#dc3545' : base.color,
                                                            backgroundColor: state.isDisabled ? '#fff3f3' : (state.isFocused ? '#e9ecef' : base.backgroundColor),
                                                            cursor: state.isDisabled ? 'not-allowed' : 'pointer',
                                                            opacity: 1
                                                        })
                                                    }}
                                                    menuPortalTarget={
                                                        document.body
                                                    }
                                                />
                                                {errors.rows?.[index]?.assetId && (
                                                    <div className="text-danger small mt-1">
                                                        {errors.rows[index].assetId}
                                                    </div>
                                                )}
                                            </td>
                                            <td className="align-top pt-2" data-label="Lỗi thiết bị">
                                                <Form.Control
                                                    type="text"
                                                    size="sm"
                                                    value={row.deviceError || ''}
                                                    onChange={(e) =>
                                                        updateRow(
                                                            row.id,
                                                            'deviceError',
                                                            e.target.value
                                                        )
                                                    }
                                                    placeholder="Mô tả lỗi..."
                                                />
                                            </td>
                                            <td className="align-top pt-2" data-label="Nội dung sửa chữa *">
                                                <Form.Control
                                                    type="text"
                                                    size="sm"
                                                    value={row.eventName}
                                                    onChange={(e) => {
                                                        updateRow(
                                                            row.id,
                                                            'eventName',
                                                            e.target.value
                                                        );
                                                        if (errors.rows?.[index]?.eventName) {
                                                            const newRowErrors = [...errors.rows];
                                                            newRowErrors[index].eventName = null;
                                                            setErrors({...errors, rows: newRowErrors});
                                                        }
                                                    }}
                                                    placeholder="Nội dung sửa chữa..."
                                                    isInvalid={!!errors.rows?.[index]?.eventName}
                                                />
                                                <Form.Control.Feedback type="invalid" className="small">
                                                    {errors.rows?.[index]?.eventName}
                                                </Form.Control.Feedback>
                                            </td>

                                            <td className="text-center align-top pt-2" data-label="Ngày bắt đầu">
                                                <DatePicker
                                                    selected={row.eventDate}
                                                    onChange={(date) =>
                                                        updateRow(
                                                            row.id,
                                                            'eventDate',
                                                            date
                                                        )
                                                    }
                                                    dateFormat="dd/MM/yyyy"
                                                    minDate={new Date()}
                                                    className="form-control form-control-sm text-left text-md-center"
                                                    portalId="root"
                                                    popperPlacement="bottom-end"
                                                />
                                            </td>
                                            <td className="text-center align-top pt-2" data-label="Hạn hoàn thành">
                                                <DatePicker
                                                    selected={row.endDate}
                                                    onChange={(date) =>
                                                        updateRow(
                                                            row.id,
                                                            'endDate',
                                                            date
                                                        )
                                                    }
                                                    dateFormat="dd/MM/yyyy"
                                                    placeholderText="Chọn..."
                                                    minDate={row.eventDate}
                                                    className="form-control form-control-sm text-left text-md-center"
                                                    portalId="root"
                                                    popperPlacement="bottom-end"
                                                />
                                            </td>
                                            <td className="align-top pt-2" data-label="Chi phí">
                                                <Form.Control
                                                    type="number"
                                                    size="sm"
                                                    min={0}
                                                    value={row.cost}
                                                    onChange={(e) =>
                                                        updateRow(
                                                            row.id,
                                                            'cost',
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                            </td>
                                            <td className="text-center align-top pt-2" data-label="Xóa">
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-danger btn-sm btn-delete-row"
                                                    onClick={() =>
                                                        removeRow(row.id)
                                                    }
                                                >
                                                    <i className="fas fa-trash-alt" />
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                            <BSButton
                                variant="outline-primary"
                                size="sm"
                                onClick={addRow}
                                className="mb-3"
                            >
                                <i className="fas fa-plus mr-1" /> Thêm thiết bị
                            </BSButton>
                        </Tab>

                        <Tab
                            eventKey="accessories"
                            title={
                                <span>
                                    <i className="fas fa-puzzle-piece mr-1" />{' '}
                                    2. Phụ kiện / Vật tư
                                </span>
                            }
                        >
                            <Table
                                striped
                                bordered
                                hover
                                responsive
                                size="sm"
                                className="mb-3 align-middle-table mobile-card-view"
                            >
                                <thead className="bg-secondary text-white text-center">
                                    <tr>
                                        <th
                                            style={{width: '40px'}}
                                            className="align-middle"
                                        >
                                            #
                                        </th>
                                        <th className="align-middle">
                                            Loại phụ kiện / Vật tư{' '}
                                            <span className="text-danger">
                                                *
                                            </span>
                                        </th>
                                        <th
                                            style={{width: '100px'}}
                                            className="align-middle"
                                        >
                                            Số lượng
                                        </th>
                                        <th
                                            style={{width: '140px'}}
                                            className="align-middle"
                                        >
                                            Đơn giá dự kiến
                                        </th>
                                        <th className="align-middle">
                                            Ghi chú
                                        </th>
                                        <th
                                            style={{width: '40px'}}
                                            className="align-middle"
                                        >
                                            Xoá
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {materials.length === 0 ? (
                                        <tr>
                                            <td
                                                colSpan="6"
                                                className="text-center p-3 text-muted empty-row"
                                            >
                                                Chưa có phụ kiện nào đi kèm
                                            </td>
                                        </tr>
                                    ) : (
                                        materials.map((mat, index) => (
                                            <tr key={mat.id}>
                                                <td className="text-center align-top pt-2 stt-mobile" data-label="STT">
                                                    {index + 1}
                                                </td>
                                                <td className="align-top pt-2" data-label="Loại phụ kiện / Vật tư *">
                                                    <Select
                                                        options={catalogOptions}
                                                        value={catalogOptions.find(
                                                            (o) =>
                                                                o.value ===
                                                                mat.materialCatalogId
                                                        )}
                                                        onChange={(opt) =>
                                                            updateMaterial(
                                                                mat.id,
                                                                'materialCatalogId',
                                                                opt?.value
                                                            )
                                                        }
                                                        isInvalid={!!errors.materials?.[index]?.materialCatalogId}
                                                        placeholder="Chọn vật tư..."
                                                        menuPortalTarget={
                                                            document.body
                                                        }
                                                        styles={{
                                                            control: (
                                                                base
                                                            ) => ({
                                                                ...base,
                                                                height: '31px',
                                                                minHeight:
                                                                    '31px',
                                                                fontSize: '13px',
                                                                borderColor: errors.materials?.[index]?.materialCatalogId ? '#dc3545' : base.borderColor,
                                                                '&:hover': {
                                                                    borderColor: errors.materials?.[index]?.materialCatalogId ? '#dc3545' : base.borderColor
                                                                }
                                                            }),
                                                            valueContainer: (
                                                                base
                                                            ) => ({
                                                                ...base,
                                                                height: '30px',
                                                                padding: '0 6px'
                                                            }),
                                                            input: (base) => ({
                                                                ...base,
                                                                margin: '0px'
                                                            }),
                                                            indicatorsContainer:
                                                                (base) => ({
                                                                    ...base,
                                                                    height: '30px'
                                                                }),
                                                            menuPortal: (
                                                                base
                                                            ) => ({
                                                                ...base,
                                                                zIndex: 9999
                                                            })
                                                        }}
                                                    />
                                                    {errors.materials?.[index]?.materialCatalogId && (
                                                        <div className="text-danger small mt-1">
                                                            {errors.materials[index].materialCatalogId}
                                                        </div>
                                                    )}
                                                </td>
                                                <td className="align-top pt-2" data-label="Số lượng">
                                                    <Form.Control
                                                        type="number"
                                                        size="sm"
                                                        min={1}
                                                        value={mat.quantity}
                                                        onChange={(e) =>
                                                            updateMaterial(
                                                                mat.id,
                                                                'quantity',
                                                                parseInt(
                                                                    e.target
                                                                        .value
                                                                ) || 0
                                                            )
                                                        }
                                                        isInvalid={!!errors.materials?.[index]?.quantity}
                                                    />
                                                    <Form.Control.Feedback type="invalid" className="small">
                                                        {errors.materials?.[index]?.quantity}
                                                    </Form.Control.Feedback>
                                                </td>
                                                <td className="align-top pt-2" data-label="Đơn giá dự kiến">
                                                    <Form.Control
                                                        type="number"
                                                        size="sm"
                                                        value={mat.unitPrice}
                                                        onChange={(e) =>
                                                            updateMaterial(
                                                                mat.id,
                                                                'unitPrice',
                                                                parseFloat(
                                                                    e.target
                                                                        .value
                                                                ) || 0
                                                            )
                                                        }
                                                    />
                                                </td>
                                                <td className="align-top pt-2" data-label="Ghi chú">
                                                    <Form.Control
                                                        type="text"
                                                        size="sm"
                                                        value={mat.note}
                                                        onChange={(e) =>
                                                            updateMaterial(
                                                                mat.id,
                                                                'note',
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                </td>
                                                <td className="text-center align-top pt-2" data-label="Xóa">
                                                    <button
                                                        type="button"
                                                        className="btn btn-outline-danger btn-sm btn-delete-row"
                                                        onClick={() =>
                                                            removeMaterial(
                                                                mat.id
                                                            )
                                                        }
                                                    >
                                                        <i className="fas fa-trash-alt" /> 
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </Table>
                            <BSButton
                                variant="outline-info"
                                size="sm"
                                onClick={addMaterial}
                                className="mb-3"
                            >
                                <i className="fas fa-laptop-medical mr-1" />{' '}
                                Thêm phụ kiện đi kèm
                            </BSButton>
                        </Tab>
                    </Tabs>

                    <div className="d-flex justify-content-end mt-4">
                        <BSButton
                            variant="secondary"
                            onClick={() =>
                                history.push(
                                    URI_INTERNAL.MAINTENANCE_BATCH_PATH
                                )
                            }
                            className="mr-2"
                            disabled={isSaving}
                        >
                            Quay lại
                        </BSButton>
                        <BSButton
                            variant="success"
                            onClick={handleSave}
                            disabled={isSaving}
                        >
                            {isSaving ? (
                                <>
                                    <span className="spinner-border spinner-border-sm mr-2" />{' '}
                                    Đang lưu...
                                </>
                            ) : (
                                <>
                                    <i className="fas fa-save mr-2" /> Lưu phiếu
                                </>
                            )}
                        </BSButton>
                    </div>
                </Card.Body>
            </Card>

            
        </div>
    );
};

export default MaintenanceBatchAdd;
